import { bool, object } from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';

import Tooltip from 'ravenjs/lib/Tooltip';
import { getThemeProps } from 'ravenjs/utils/theme';

import { AriesIcon } from 'components/Icons';
import { TRY_ARIES } from 'constants/ai';
import MESSAGES from 'constants/messages';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const NewToolIcon = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.media.up('md')`
        margin: 0 0.53rem;
    `};
    &::before {
        content: '';
        position: absolute;
        background-color: ${MIGRATED_COLORS.blue};
        width: 8px;
        height: 8px;
        top: -4px;
        right: -4px;
        border-radius: 50%;
    }
`;

function AINav({ theme, isDisabled }) {
    const renderIcon = () => {
        return (
            <NewToolIcon style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}>
                <AriesIcon
                    fill={getThemeProps('NavItem.styles.color', MIGRATED_COLORS.black, {
                        theme,
                    })}
                    width="20px"
                    height="20px"
                    cursor={isDisabled ? 'not-allowed' : 'pointer'}
                    isActive
                    onClick={
                        isDisabled
                            ? e => {
                                  e.preventDefault();
                              }
                            : () => {
                                  window.location.href = '/aries';
                              }
                    }
                />
            </NewToolIcon>
        );
    };

    return (
        <Tooltip
            content={isDisabled ? MESSAGES.RESTRICTED_NAV_ITEM : TRY_ARIES}
            padding="4px 16px"
            margin={0}
            arrowSize={5}
            placement="top"
            borderRadius="5px"
        >
            {renderIcon()}
        </Tooltip>
    );
}

AINav.propTypes = {
    isDisabled: bool,
    theme: object.isRequired,
};

AINav.defaultProps = {
    isDisabled: false,
};

export { AINav as AINavUnwrapped };
export default withTheme(AINav);
